import { ChangeEvent } from 'react'
import { useNavigate } from 'react-router-dom'
import { debounce } from 'lodash'
import { TextField } from '@iziplay/ui-kit'
import './searchbar.css'

export const SearchBar = () => {
  const navigate = useNavigate()

  const search = debounce(value => {
    if (!value || value === '') return
    navigate(`/search?query=${encodeURIComponent(value)}`)
  }, 500)

  function onChange(event: ChangeEvent<HTMLInputElement>) {
    search(event.target.value)
  }

  return (
    <div className="search">
      <TextField
        id="searchInput"
        type="text"
        onChange={onChange}
        placeholder="Search a movie, tv show or people"
      />
    </div>
  )
}
